<template>
  <div >
   <div class="input-group mb-3" dir="ltr">
  <input
      type="text"
      class="form-control text-center "
      v-model="userInput"
      placeholder="کد را وارد کنید"
      @input="validateCaptcha"
      maxlength="5"
      v-mask="'#####'"
    />
  <div class="input-group-append">
    <canvas
      ref="canvas"
      class="input-group-text"
      :width="width"
      :height="height"
      @click="generateCaptcha"
      title="برای تولید کد جدید روی تصویر کلیک کنید"
    ></canvas>
  </div>
</div>
    <!-- <p v-if="result" class="text-center mt-1">{{ result }}</p> -->
  </div>
</template>

<script>
export default {
  name: "CaptchaBox",
  props: {
    width: {
      type: Number,
      default: 130,
    },
    height: {
      type: Number,
      default: 37,
    },
  },
  data() {
    return {
      captchaCode: "",
      userInput: "",
      result: "",
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.generateCaptcha();
    });
  },
  methods: {
    randomColor() {
      const r = Math.floor(Math.random() * 256);
      const g = Math.floor(Math.random() * 256);
      const b = Math.floor(Math.random() * 256);
      return `rgb(${r},${g},${b})`;
    },
    generateCaptcha() {
      const canvas = this.$refs.canvas;
      if (!canvas) return; 

      const ctx = canvas.getContext("2d");
      const chars = "0123456789";
      this.captchaCode = Array.from({ length: 5 }, () =>
        chars[Math.floor(Math.random() * chars.length)]
      ).join("");

      ctx.clearRect(0, 0, this.width, this.height);

      ctx.fillStyle = "#f2f2f2";
      ctx.fillRect(0, 0, this.width, this.height);

      for (let i = 0; i < 5; i++) {
        ctx.strokeStyle = this.randomColor();
        ctx.beginPath();
        ctx.moveTo(Math.random() * this.width, Math.random() * this.height);
        ctx.lineTo(Math.random() * this.width, Math.random() * this.height);
        ctx.stroke();
      }

      ctx.font = "26px Arial";
      ctx.fillStyle = "#333";
      ctx.textBaseline = "middle";
      ctx.textAlign = "center";
      ctx.fillText(this.captchaCode, this.width / 2, this.height / 2);

      for (let i = 0; i < 30; i++) {
        ctx.fillStyle = this.randomColor();
        ctx.fillRect(Math.random() * this.width, Math.random() * this.height, 1.5, 1.5);
      }

      this.userInput = "";
      this.result = "";
    },
    validateCaptcha() {
      if (this.userInput.length === this.captchaCode.length) {
        if (this.userInput.toString() === this.captchaCode.toString()) {
          this.result = "✅ کد صحیح است";
          this.$emit("valid", true);
        } else {
          this.result = "❌ کد اشتباه است";
          this.$emit("valid", false);
        }
      } else {
        this.result = "";
        this.$emit("valid", false);
      }
    },
  },
};
</script>
<style scoped>
.input-group-text{
    padding: 0% !important;
    cursor: pointer;
}
</style>
